import React, { useRef } from "react";

// Once a field is answered, make sure the following one is on screen. Fields
// below the fold are easy to miss entirely and the user only finds out when
// Next rejects the form.
const useRevealNextField = () => {
  const fieldsRef = useRef<HTMLDivElement>(null);

  const revealFieldAfter = (index: number) => {
    // Let the dropdown close and the layout settle before measuring.
    window.setTimeout(() => {
      const next = fieldsRef.current?.children[index + 1];
      next?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 80);
  };

  const handleFieldInteraction = (
    event: React.SyntheticEvent,
    index: number,
  ) => {
    const target = event.target as HTMLElement | null;
    // Only react to committing a choice, not to opening the dropdown. The
    // option lives in a portal, so this arrives via the React tree, not the DOM.
    const committed =
      !!target?.closest?.('[role="option"]') ||
      !!target?.closest?.('input[type="radio"]') ||
      (event.type === "keydown" &&
        (event as React.KeyboardEvent).key === "Enter");

    if (committed) {
      revealFieldAfter(index);
    }
  };

  return { fieldsRef, handleFieldInteraction };
};

export default useRevealNextField;
